import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  universalCorporationId: string
  targetUniversalUid: string
}

export class AddToCorporationFavoriteUserList extends WriteRequest<void> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    const { targetUniversalUid } = this.params
    return this.apiClient.post(this.makeEndpoint(), { targetUniversalUid })
  }

  private makeEndpoint(): string {
    return `/favorite_user/corporation_member/${this.params.universalCorporationId}/corporation_favorite_user_list/add`
  }
}
